function pages(backendAxiosInstance) {
  async function getPage(pageId, sportIds) {
    return backendAxiosInstance.get(`/layouts/v3/pages/${pageId}`, {
      includeLanguage: true,
      params: sportIds
    });
  }
  return {
    getPage
  };
}

export { pages as default };
//# sourceMappingURL=pages.js.map
